import { Tab, tabList } from "@/constants/mobile";
import React, { useRef, useState, useEffect } from "react";
import AIIcon from "@/assets/summary/ai.svg";
import SearchIcon from "@/assets/record/ic_search_mobile.svg?react";
import SearchBarMobile from "@/component/SearchBarMobile";
import fridayReporter from "@/utils/friday";
import { SRC_CONTENT_CLASSNAME } from "@/constants/record";
import ExportIcon from "@/assets/summary/ic_download.svg?react";
import MobileExportModal, {
  MobileExportModalRef,
} from "@/component/MobileExportModal";
import summaryCommonStore from "@/store/summaryCommon.store";
import ShareActionSheet from "@/sections/ShareActionSheet";
import IcShare from "@/assets/share/ic_share.svg?react";
import summarySrcStore from "@/store/summarySrc.store";
import useExport from "@/sections/Summary/useExport";

interface ITabListProps {
  activeTab: Tab;
  setActiveTab: React.Dispatch<React.SetStateAction<Tab>>;
  disabled?: boolean;
  fromShare?: boolean;
  isOnlyOriginal?: boolean;
}

export default function TabList({
  activeTab,
  setActiveTab,
  disabled,
  fromShare,
  isOnlyOriginal,
}: ITabListProps) {
  const shareInfo = summaryCommonStore((state) => state.shareInfo);
  // 风险待审查
  const detailInfo = summarySrcStore((state) => state.detailInfo);
  const generatedTitle = summarySrcStore((state) => state.generatedTitle);
  const { showExportBtn } = useExport();
  console.log('detailInfo = ', detailInfo);

  // 当智能总结 tab 被隐藏且当前 activeTab 是 summary 时，自动切换到 originalText
  useEffect(() => {
    if (fromShare && isOnlyOriginal && activeTab === Tab.summary) {
      setActiveTab(Tab.originalText);
    }
  }, [fromShare, isOnlyOriginal, activeTab, setActiveTab]);

  const handleClickTab = (id: Tab) => {
    if (disabled) return;
    setActiveTab(id);
    if (id === Tab.originalText) {
      fridayReporter.pushData({
        eventCode: "summary_h5_text",
      });
    }
  };
  const [searching, setSearching] = useState(false);
  const exportModalRef = useRef<MobileExportModalRef>(null);

  const handleSearching = () => {
    fridayReporter.pushData({
      eventCode: "summary_h5_search",
    });
    setSearching(true);
  };

  const handleCancelSearching = () => {
    setSearching(false);
  };

  const handleShowDownloadModal = () => {
    exportModalRef.current?.show();
  };

  return (
    <>
      {tabList.map((tab, index) => (
        <div
          key={tab.id}
          className={`text-4.5 position-relative lh-6.5 text-mx-secondary ${index === 0 ? "ml-0" : "ml-10.5"
            } ${activeTab === tab.id ? "font-600" : disabled ? "opacity-30" : ""
            }`}
          onClick={() => handleClickTab(tab.id)}
        >
          {tab.value}
          {tab.id === Tab.summary && (
            <img
              className="w-4 h-4 position-absolute right--4.5"
              src={AIIcon}
            />
          )}
          {activeTab === tab.id && (
            <div
              className={`position-absolute z-1  left-0 bottom--1 ${activeTab === Tab.originalText ? "w-6.5" : "w-11"
                } h-0.5 bg-gradient-to-r from-#A28CE2  to-#80B0FF rounded-25`}
            ></div>
          )}
        </div>
      ))}
      {!searching && (
        <div className="absolute right-0 flex items-center">
          {!shareInfo && showExportBtn &&  (
            <ExportIcon
              className="w-8 h-8"
              onClick={handleShowDownloadModal}
            />
          )}
          {!fromShare && <ShareActionSheet streamName={detailInfo?.streamName || ""} title={generatedTitle || ""}>
            <IcShare className="w-8 h-8 ml-2" />
          </ShareActionSheet>}
          {activeTab === Tab.originalText && (
            <SearchIcon
              className="ml-3 flex items-center w-4 h-4"
              onClick={handleSearching}
            />
          )}
        </div>
      )}
      {activeTab === Tab.originalText && searching && (
        <div className="absolute right-0 left-0 top-0 h-9 flex items-center justify-between">
          <SearchBarMobile
            querySelector={`.${SRC_CONTENT_CLASSNAME}`}
            onCancel={handleCancelSearching}
          />
        </div>
      )}
      <MobileExportModal
        ref={exportModalRef}
      />
    </>
  );
}
